export const CITIES_PER_PAGE = 100;
export const USERS_PER_PAGE = 2000;
export const STORE_LOGS_PER_PAGE = 20;

export const DEVICES_PER_PAGE = 2000;

export const ORGANIZATIONS_PER_PAGE = 2000;

export const RELEASE_PER_PAGE = 20;

export const ATTRACTIONS_PER_PAGE = 20;
export const ATTRACTIONS_LIST_PER_PAGE = 20;

export const INMAILS_PER_PAGE = 20;
